import React, { ReactNode } from "react"
import Layout from "../../components/Layout/Layout"
import SecondTitle from "../../components/UI/SecondTitle/SecondTitle"
import Image from "../../components/UI/Image"
import * as styles from "./projectLayout.module.scss"

type ProjectLayoutProps = {
	location?: {
		pathname: string
	}
	title: string
	description?: any
	date?: string
	client: string
	expretise: string
	desktopImage: string
	projectImage?: string
	mobileImage?: string
	titleColor?: string
	children?: ReactNode
	border?: boolean
	back?: "white" | "dark"
}

const ProjectLayout: React.FC<ProjectLayoutProps> = ({
	title,
	date,
	client,
	back,
	expretise,
	projectImage,
	description,
	children,
	desktopImage,
	titleColor,
	location,
	mobileImage,
	border
}) => {
	return (
		<Layout location={location}>
			<article className={styles.projectPage}>
				<SecondTitle
					desktopImage={desktopImage}
					mobileImage={mobileImage}
					title={title}
					titleColor={titleColor}
					position="center center"
					back={back}
				/>
				<div className="container">
					<div className={styles.projectGrid}>
						<div className={styles.projectLeft}>
							<p>{description}</p>
						</div>

						<div className={styles.projectRight}>
							<p>
								<span>Client</span>
								{client}
							</p>
							<p>
								<span>Expertise</span>
								{expretise}
							</p>
							<p>
								<span>Date</span>
								{date}
							</p>
						</div>
					</div>
					{projectImage &&
						<div className={styles.projectImage} style={border ? { border: "2px solid #212121" } : undefined}>
							<Image
								src={projectImage}
								alt={title}
								fill
							/>
						</div>
					}
					{/* Произвольный контент */}
					{children && <>{children}</>}
				</div>
			</article>
		</Layout>
	)
}

export default ProjectLayout
